module.exports = __webpack_public_path__ + "img/close-outline.a9e31d60.svg";